import React from 'react';
import { type Theme, useTheme } from '@mui/material/styles';

import { ProcessTalentResponseDTOStatus } from '@/api/generated';

import CircleIcon, { CircleIconProps } from './CircleIcon/CircleIcon';

const ProcessStatusIcon = ({ status }: { status: ProcessTalentResponseDTOStatus | undefined }) => {
  const { palette } = useTheme();

  return <CircleIcon stroke="transparent" {...getStatusStylesProps(status, palette)} />;
};

export default ProcessStatusIcon;

const getStatusStylesProps = (
  status: ProcessTalentResponseDTOStatus | undefined,
  palette: Theme['palette']
): Pick<CircleIconProps, 'fill' | 'stroke'> | undefined => {
  switch (status) {
    case ProcessTalentResponseDTOStatus.ACTIVE:
      return { fill: palette.green[700] };
    case ProcessTalentResponseDTOStatus.CANCELLED:
      return { fill: palette.red[900] };
    case ProcessTalentResponseDTOStatus.UNPUBLISHED:
      return { stroke: palette.primary[500] };
    case ProcessTalentResponseDTOStatus.ON_HOLD:
      return { fill: palette.orange.main };
    case ProcessTalentResponseDTOStatus.COMPLETED:
      return { fill: palette.primary.main };
  }
};
